import { jwtDecode } from 'jwt-decode';

const validateJwt = (token) => {
    try {
        let decodedToken = jwtDecode(token);
        console.log("Decoded Token", decodedToken);
        let currentDate = new Date();

        // JWT exp is in seconds
        return decodedToken.exp * 1000 >= currentDate.getTime();
    } catch (error) {
        console.error('Invalid Token:', error.message);
        return false;
    }
};

export default validateJwt;